module.exports = __webpack_public_path__ + "static/media/vapour-img1.d99f3f62.png";